import styled from 'styled-components';
import { color } from 'styles/pallete';

export const inputBox = styled.div<{ $diseable: boolean; $isHide: boolean }>`
	position: relative;
	width: 100%;
	min-width: 0;
	display: ${(props) => (props.$isHide ? 'none' : 'flex')};
	flex-direction: column;
	gap: 0.5rem;
	position: relative;
	opacity: ${(props) => (props.$diseable ? '0.5' : '1')};

	> p {
		font-weight: 700;
		color: ${color.interface.lightGray};
		font-size: 1.4rem;
	}
`;

export const containerOption = styled.div<{ $minWidth: number }>`
	all: unset;
	width: 100%;
	min-width: ${(props) =>
		props.$minWidth === 0 ? '0' : `${props.$minWidth}px`};
	border: 1px solid ${color.interface.lightGray2};
	padding: 1rem;
	box-sizing: border-box;
	border-radius: 5px;
	display: flex;
	align-items: center;
	justify-content: center;
`;

export const titleContainer = styled.div<{ $diseable: boolean }>`
	width: 100%;
	min-width: 0;
	display: flex;
	align-items: center;
	justify-content: space-between;
	cursor: ${(props) => (props.$diseable ? ' not-allowed' : 'pointer')};
	> span {
		min-width: 0;
		font-family: nunito-regular;
		color: ${color.interface.lightGray};
		font-size: 1.5rem;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}
`;

export const line = styled.div`
	min-height: 1px;
	width: 100%;
	background-color: ${color.interface.lightGray2};
	margin-top: 1rem;
`;

export const modalOptions = styled.div<{ $placement: 'top' | 'bottom' }>`
	max-height: 100px;
	overflow-y: auto;
	overflow-x: hidden;
	z-index: 100;
	padding: 1rem 1rem 1rem 1rem;
	box-sizing: border-box;
	width: 100%;
	position: absolute;
	background-color: ${color.interface.white};
	border: 1px solid ${color.interface.lightGray2};
	border-top: ${(props) =>
		props.$placement === 'bottom'
			? 'none'
			: `1px solid ${color.interface.lightGray2}`};
	border-bottom: ${(props) =>
		props.$placement === 'top'
			? 'none'
			: `1px solid ${color.interface.lightGray2}`};
	border-radius: ${(props) =>
		props.$placement === 'top' ? '5px 5px 0 0' : '0 0 5px 5px'};
	top: ${(props) => (props.$placement === 'bottom' ? '90%' : 'auto')};
	bottom: ${(props) => (props.$placement === 'top' ? '90%' : 'auto')};
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: flex-start;
	gap: 1rem;

	p {
		margin-left: 1rem;
		width: 100%;
		cursor: pointer;
		font-size: 1.5rem;
		color: ${color.interface.lightGray};
		transition: all ease 0.1s;
		text-align: left;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
		min-height: 2rem;
		/* background-color: red; */

		:hover {
			opacity: 0.5;
			transform: scale(1.01);
		}
	}
	-webkit-box-shadow: 14px 15px 34px -8px rgba(0, 0, 0, 0.12);
	box-shadow: 14px 15px 34px -8px rgba(0, 0, 0, 0.12);
`;

export const errorMessage = styled.span`
	color: ${color.interface.red};
	font-size: 1.2rem;
`;

export const labelAndQuestionBox = styled.div`
	width: 100%;
	min-width: 0;
	display: flex;
	align-items: center;
	justify-content: flex-start;
	gap: 0.5rem;
	> p {
		min-width: 0;
		font-weight: 700;
		color: ${color.interface.lightGray};
		font-size: 1.4rem;
		overflow: hidden;
		text-overflow: ellipsis;
	}
`;
